import {
  Component,
  Input,
  Output,
  EventEmitter,
  ViewChild
} from '@angular/core';
import {
  SharedService
} from '../../shared.service';

@Component({
  selector: 'app-accordion',
  templateUrl: './accordion.component.html',
  styleUrls: ['./accordion.component.scss']
})
export class AccordionComponent {

  @Input() title;
  @Input() dataLength;
  @Input() accordionNo;
  @Input() expanded;
  @Input() addModalId;
  @Input() showAddButton;
  @Input() showEmptyFields = true;
  @Input() currentTreeTab;
  @Output() addButtonClickedEvent = new EventEmitter<any>();

  @ViewChild('accordionContent') accordionContent;

  constructor(private sharedService: SharedService) {
  }


  onArrowClicked(event) {
    this.expanded = !this.expanded;
  }

  onAddButtonClick(evt) {

    if(document.getElementById('mySidenav_table_view')) {
      document.getElementById('mySidenav_table_view').classList.add("w-100", "transition-none");
    }    

    if (evt === 'taxonomyAssociation') {
      this.sharedService.openTree.next({
        addAssociation: true,
        oldAddAssociationClicked: false
      });
    } else {
      if (evt === 'add-association') {
        this.sharedService.openTree.next({
          openTree: true,
          addAssociation: false,
          oldAddAssociationClicked: true
        });
      } else {
        this.sharedService.openTree.next({
          openTree: false,
          addAssociation: false,
          oldAddAssociationClicked: false
        });
      }
    }

    this.addButtonClickedEvent.emit();
  }
}
